<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>Support</h2>
  </div>
</div>

<div class="row">

  <div class="col-md-12">
    <div class="panel panel-card">
      <div class="panel-heading">
        <div class="panel-heading">
          <div class="card-header bp-card-header">
            <i class="fas fa-tint payment-options-icon" style="float: left;"></i>
            <p class="font-weight-light bp-text">Contact Us</p>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="panel-body support-content">
          <div class="row margin-top-25">
            <div class="col-12">
              <label for="subject">Subject</label>
              <input type="text" id="subject" [(ngModel)]="subject" class="form-control" />
            </div>
          </div>
          <div class="row margin-top-25">
            <div class="col-12">
              <label for="body">Message</label>
              <textarea rows="6" id="body" [(ngModel)]="message" class="form-control"></textarea>
            </div>
          </div>
          <div class="row margin-top-25">
            <div class="col-12">
              <button (click)="sendSupportMessage(currentAccount, subject, message)" class="btn btn-primary float-right">Send Message to Support</button>
              <label *ngIf="!showButton" class="green col-12">Message succesfully sent to our support team, someone will be in contact with you soon.</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dx-toast [(visible)]="showSuccess"
            type="success"
            message="Your message has been sent to our support team, we will get back to you shortly.">
  </dx-toast>

  <dx-toast [(visible)]="showError"
            type="error"
            message="{{error}}">
  </dx-toast>

</div>



// WEBPACK FOOTER //
// ./src/app/contact-us-container/contact-us-container.component.html